<template>
	<div class="part_build">
		<div class="pbd_pc pt_90" v-if="!isPhone">
			<pageBanner :imgurl="banner"></pageBanner>
			<location lone="党的建设" v-if="tabarr.length" :ltwo="tabarr[tabact].title"></location>
			<div class="con_wrap">
				<div class="con_box flex1">
					<div class="con_left">
						<tabson2 :titobj="tabtit" :tablist="tabarr" :actIndex="tabact" @tab-change="tabChange"></tabson2>
						<br>
						<contact></contact>
					</div>
					<div class="con_right">
						<div class="tfm_tit" v-if="tabarr.length">{{tabarr[tabact].title}}</div>
						<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
		<div class="pbd_ph" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="党的建设"></Header2>
			<pageBanner2 :imgurl="banner"></pageBanner2>
            <div class="ph_tab_box flex3">
				<div class="ph_tab_item" v-for="(item,index) in tabarr" :key="index" @click="tabChange2(index,item)">
					<span :class="tabact==index?'ph_act1':''">{{ item.title }}</span>
				</div>
			</div>
            <div class="rout_box">
                <router-view></router-view>
            </div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			tabtit: {
				title1: '党的建设',
				title2: 'Party Building',
			},
			tabact: 0,
			banner: '',
			tabarr: [],
			isPhone: this.$isMobile,
		}
	},
	computed: {
		...mapState(["headList"]),
	},
	mounted() {
		this.getTabArr(this.headList);
	},
	watch: {
        $route(to, from) {
            if (to.path == '/partyBuilding/partyList') {
				if(this.$route.query.sort > 6){
					this.tabact = Number(this.$route.query.sort-4);
				}else{
					this.tabact = Number(this.$route.query.sort-1);
				}
			}
            if (to.path == '/partyBuilding/partyCenter') {
				this.tabact = 0;
			}
		},
		headList(newVal, oldVal) {
			if (newVal.length) {
				this.getTabArr(newVal);
			}
		}
	},
	created() {
		if (this.$route.query.sort) {
			if(this.$route.query.sort > 6){
				this.tabact = Number(this.$route.query.sort-4);
			}else{
				this.tabact = Number(this.$route.query.sort) - 1;
			}
		}
	},
	methods: {
		getTabArr(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].name == '/partyBuilding/partyCenter') {
					this.banner = this.$staticImg + arr[i].image;
					this.tabarr = arr[i].son;
				}
			}
		},
		tabChange(index) {
			this.tabact = index;
		},
        tabChange2(index,item){
            this.tabact = index;
            this.$router.push(item.name);
        }
	}
}
</script>

<style lang="scss">
.part_build {
    .pbd_pc{

    }
    .pbd_ph{
        padding-top: 1.23rem;
        padding-bottom: 80px;
    }
}
</style>